import { render } from "./DirectLink.vue?vue&type=template&id=06e83f54&scoped=true"
import script from "./DirectLink.vue?vue&type=script&lang=js"
export * from "./DirectLink.vue?vue&type=script&lang=js"

import "./DirectLink.vue?vue&type=style&index=0&id=06e83f54&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e83f54"]])

export default __exports__